import { log } from '@/log'
import {
  initialOrderAggregation,
  OrderAggregationRepository,
  ResultGetForCurrentUser,
} from '@/models/order/aggregation/order-aggregation'
import { CurrentUser, parseOrderAggregation } from '@/services/api/current-user'
import parse from 'date-fns/parse'
import { left, right } from 'fp-ts/lib/Either'

/**
 * current_userリソースに記載された情報を使って{@link OrderAggregation}を生成するリポジトリ.
 */
export class OrderAggregationRepositoryWithCurrentUser implements OrderAggregationRepository {
  constructor(private readonly currentUserService: CurrentUser) {}

  async getForCurrentUser(): Promise<ResultGetForCurrentUser> {
    return this.currentUserService.getCurrentUser().then(result => result.fold<ResultGetForCurrentUser>(
      left,
      user => parseOrderAggregation(user).fold(
        (errors) => {
          log.error('could not parse order aggregation', errors)

          return left(new Error(errors.map(e => e.message).join(',')))
        },
        parseResult => right(parseResult.map(
          data => data.last_purchased_date !== null
          ? {
            lastPurchasedDate: parse(data.last_purchased_date),
            lastPurchasedAmount: data.last_purchased_amount,
            totalPurchasedCount: data.total_purchased_count,
            totalPurchasedAmount: data.total_purchased_amount,
          }
          : initialOrderAggregation
        ))
      )
    ))
  }
}
